module.exports = __webpack_public_path__ + "static/media/about5.066c037c.webp";